'use client';

import { type ReactNode } from 'react';
import { NovuProvider } from '@novu/react';
import { useAuth } from '@/infrastructure/auth';
import { isNovuEnabled } from './novu-config';

const NOVU_APP_ID = process.env.NEXT_PUBLIC_NOVU_APP_ID ?? '';
const NOVU_API_URL = process.env.NEXT_PUBLIC_NOVU_API_URL;
const NOVU_SOCKET_URL = process.env.NEXT_PUBLIC_NOVU_SOCKET_URL;

interface NovuClientProviderProps {
  children: ReactNode;
}

export function NovuClientProvider({ children }: NovuClientProviderProps) {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user || !isNovuEnabled()) {
    return <>{children}</>;
  }

  return (
    <NovuProvider
      applicationIdentifier={NOVU_APP_ID}
      subscriberId={user.uuid}
      {...(NOVU_API_URL && { backendUrl: NOVU_API_URL })}
      {...(NOVU_SOCKET_URL && { socketUrl: NOVU_SOCKET_URL })}
    >
      {children}
    </NovuProvider>
  );
}
